export const apiURL = (path: string) => {
  return `${process.env.REACT_APP_API_HOST}${path}`;
};
export const websiteURL = (path: string) => {
  return `${process.env.REACT_APP_SITE_URL}${path}`;
};
